import React, { useState ,useEffect} from "react";
import {
  Box,
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BASE_URL } from "../../../components/BaseUrl";

import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption";
import { toast } from "react-hot-toast";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  borderRadius: 2,
  p: 3,
  boxShadow: 24,
};

const EditAbsenceModal = ({ open, onClose, row, onUpdated }) => {
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
 const {t} =useTranslation()
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
useEffect(() => {
  if (open && row?.id) {
    console.log("Editing Absence ID:", row.id);
  }
}, [open, row]);
  const handleUpdate = async () => {
    if (!row?.id) {
      toast.error("Invalid Absence ID!");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        `${BASE_URL}/absences/admin/absences/${row.id}/comment`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ comment }),
        }
      );

      const json = await res.json();

      if (!json.error) {
        toast.success("Absence updated successfully!");

        onUpdated(); // Refresh table
        onClose(); // Close modal
        setComment(""); // Reset field
      } else {
        toast.error(json.message || "Failed to update.");
      }
    } catch (err) {
      console.log("Update Error:", err);
      toast.error("Network error while updating.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              textAlign: "left",
              flex: 1,
              color: "#003149",
              fontFamily: "Poppins",
            }}
          >
      {t("absence.editModel.heading")}
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Comment Label */}
        <Typography

sx={{
      fontSize: "14px",
  fontWeight: 500,
     fontFamily: 'Poppins, sans-serif',
color:"#6B778C",
  display: "inline-block",
  marginBottom: "4px"
}}
        >
         {t("absence.editModel.comment_label")}
        </Typography>

        {/* Textarea */}
        <textarea  
          value={comment}
          onChange={(e) => setComment(e.target.value)}
       placeholder={t("absence.editModel.comment_placeholder")}
          style={{ mb: 3, fontFamily: "Poppins",width:"100%",height:"65px",paddingTop:"5px" }}
          className='project_input'
        />

        {/* Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2,mt:2, }}>
          <Button
            onClick={onClose}
            disabled={loading}
            sx={{
              textTransform: "none",
              fontFamily: "Poppins",
              color: "#6b7280",
            }}
          >
            {t("absence.editModel.cancel")}
          </Button>
<CustomButton
  label={
    loading ? (
      <CircularProgress size={18} sx={{ color: "white" }} />
    ) : (
  t("absence.editModel.update")
    )
  }
  size="small"
  onClick={handleUpdate}
  disabled={loading}
  sx={{
    minWidth: 100,
    backgroundColor: "#003149",
    ":hover": { backgroundColor: "#014065" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
/>

        </Box>
      </Box>
    </Modal>
  );
};

export default EditAbsenceModal;
